/**
 * File: apps/qbench-cp/reactapp/src/shared/utils/queryClient.js
 *
 * Purpose: Configures and exports the shared react-query `QueryClient` instance for the
 *     customer portal.
 *
 * Scope: Global react-query client configuration.
 *
 * Tags: customer-portal
 *
 * Overview: Instantiates a single `QueryClient` with `refetchOnWindowFocus` disabled,
 *     `retry` disabled, and `staleTime` set to Infinity so queries are treated as cached
 *     indefinitely until explicitly invalidated.
 *
 * Exports: queryClient
 */

import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity,
    },
  },
});
